/**
 * Deployment-level branding configuration.
 *
 * The name of the brokerage/organization operating this instance. Since the app
 * no longer supports multiple tenants within a single API (a new tenant means a
 * new AWS instance), this is a constant per deployment rather than per-user data,
 * and is sourced from the `VITE_ORG_NAME` build-time environment variable.
 *
 * Returns an empty string when unset so display fallbacks (e.g. "External" vs
 * "Non-<org>") continue to work.
 */
export function orgName(): string {
  return (import.meta.env.VITE_ORG_NAME ?? '').trim();
}

/**
 * "Non-<org>" when the org name is configured, "External" when it is not.
 */
export function externalPolicyName(): string {
  const org = orgName();
  return org !== '' ? `Non-${org}` : 'External';
}

export function includeExternalPoliciesLabel(): string {
  return `Include ${externalPolicyName()} Policies`;
}
